import React, { useState } from 'react';
import { Container, Accordion, Button } from 'react-bootstrap';
import "../assets/styles/FrequentlyQuestions.css";

const faqs = [
  {
    question: 'What is UI/UX Design?',
    answer:
      'UI (User Interface) design focuses on the visual elements of an app or website, like layout and buttons. UX (User Experience) design is about the overall feel and functionality, aiming to provide a seamless and intuitive user experience.',
  },
  {
    question: 'Why is UI/UX Design services are important for my business?',
    answer:
      'Good UI/UX design enhances user satisfaction, increases user engagement, and can significantly boost conversions and retention rates, directly impacting your business’s success.',
  },
  {
    question: 'How does the UI/UX design process work?',
    answer: '',
  },
  {
    question: 'Can UI/UX design improve my website/app’s performance?',
    answer: '',
  },
  {
    question: 'What are the latest trends in UI/UX design?',
    answer: '',
  },
];

const FaqPage = () => {
  const [activeKey, setActiveKey] = useState(['0', '1']);

  const toggleItem = (key) => {
    setActiveKey((prevKeys) =>
      prevKeys.includes(key)
        ? prevKeys.filter((k) => k !== key)
        : [...prevKeys, key]
    );
  };

  return (
    <Container fluid className="faq-wrapper">
      <Container className="faq-inner">
        <h3 className='mb-5 feq-main-title'>Frequently Asked Questions</h3>
        <Accordion activeKey={activeKey}>
          {faqs.map((item, index) => (
            <Accordion.Item
              eventKey={index.toString()}
              key={index}
              className="faq-item"
            >
              <Accordion.Header onClick={() => toggleItem(index.toString())}>
                <span className="faq-question">{item.question}</span>
               
              </Accordion.Header>
              {item.answer && (
                <Accordion.Body>{item.answer}</Accordion.Body>
              )}
            </Accordion.Item>
          ))}
        </Accordion>
        <div className="load-more-wrapper">
          <Button className="load-more-btn">Load More</Button>
        </div>
      </Container>
    </Container>
  );
};

export default FaqPage;
